import M$plugin$FullTOC from './/facade/js/fulltoc';
import M$control$FullTOCControl from './/facade/js/fulltoccontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
window.M.plugin.FullTOC = M$plugin$FullTOC;
window.M.control.FullTOCControl = M$control$FullTOCControl;
